import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import MobileSlider from './slider/MobileSlider';
import DesktopSlider from './slider/DesktopSlider';
import ExpertReport from './ExpertReport';
import MachineInformation from './MachineInformation';
import ImportantInformations from './ImportantInformations';

const ContentBody = ({
  machine,
  offers,
  setGalleryContent,
  setDownloadReportModalVisible,
  setTooltipPosition,
  setHowToAuctionWorkModalVisible,
  setMarketPlaceModalVisible,
  setCheckBidModalData,
  minimumIncrement,
  machineSoldPrice,
}) => {
  const [windowScale, setWindowScale] = useState(600);

  const reportMedias = useMemo(() => [
    ...machine.report.videos.map((video) => ({ ...video, type: 'video' })),
    ...machine.report.images.map((image) => ({ ...image, type: 'image' })),
  ], [machine]);

  useEffect(() => {
    if (window) {
      setWindowScale(window.innerWidth);
    }
  }, []);

  return (
    <>
      <div className="col-15 col-lg-9">
        <MobileSlider
          medias={reportMedias}
          setGalleryContent={setGalleryContent}
        />
        <DesktopSlider
          medias={reportMedias}
          setGalleryContent={setGalleryContent}
        />
        {
          windowScale.innerWidth < 500
            ? (
              <aside>
                <MachineInformation
                  setHowToAuctionWorkModalVisible={setHowToAuctionWorkModalVisible}
                  machine={machine}
                  setMarketPlaceModalVisible={setMarketPlaceModalVisible}
                  offers={offers}
                  setCheckBidModalData={setCheckBidModalData}
                  minimumIncrement={minimumIncrement}
                  machineSoldPrice={machineSoldPrice}
                />
                <ImportantInformations machine={machine} />
              </aside>
            )
            : (
              <ExpertReport
                setDownloadReportModalVisible={setDownloadReportModalVisible}
                report={machine.report}
                setGalleryContent={setGalleryContent}
                setTooltipPosition={setTooltipPosition}
              />
            )
        }
      </div>
      {/* RIGHT */}
      <div className="col-15 col-lg-6">
        {
          windowScale.innerWidth < 500
            ? (
              <ExpertReport
                setDownloadReportModalVisible={setDownloadReportModalVisible}
                report={machine.report}
                setGalleryContent={setGalleryContent}
                setTooltipPosition={setTooltipPosition}
              />
            )
            : (
              <aside>
                <MachineInformation
                  setHowToAuctionWorkModalVisible={setHowToAuctionWorkModalVisible}
                  machine={machine}
                  setMarketPlaceModalVisible={setMarketPlaceModalVisible}
                  offers={offers}
                  setCheckBidModalData={setCheckBidModalData}
                  minimumIncrement={minimumIncrement}
                  machineSoldPrice={machineSoldPrice}
                />
                <ImportantInformations machine={machine} />
              </aside>
            )
        }
      </div>
    </>
  );
};

ContentBody.propTypes = {
  machine: PropTypes.object,
  offers: PropTypes.array,
  setGalleryContent: PropTypes.func,
  setDownloadReportModalVisible: PropTypes.func,
  setTooltipPosition: PropTypes.func,
  setHowToAuctionWorkModalVisible: PropTypes.func,
  setMarketPlaceModalVisible: PropTypes.func,
  setCheckBidModalData: PropTypes.func,
  minimumIncrement: PropTypes.number,
  machineSoldPrice: PropTypes.number,
};

export default ContentBody;
